import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Image, Card, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { fetchOneDevice } from '../http/deviceAPI';
import { Context } from '../index';
import { useContext } from 'react';
import star from '../assets/star.png';

const DevicePage = observer(() => {
    const { id } = useParams();
    const { basket } = useContext(Context);
    const [device, setDevice] = useState(null);
    const [loading, setLoading] = useState(true);
    const [added, setAdded] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchOneDevice(id)
            .then(data => {
                setDevice(data);
                setLoading(false);
            })
            .catch(err => {
                console.error('Ошибка загрузки устройства:', err);
                setLoading(false);
            });
    }, [id]);

    const handleAddToBasket = async () => {
        await basket.addDevice(device);
        setAdded(true);
        setTimeout(() => setAdded(false), 2000);
    };

    if (loading) {
        return (
            <Container className="mt-5 text-center">
                <h3>Загрузка...</h3>
            </Container>
        );
    }

    if (!device) {
        return (
            <Container className="mt-5 text-center">
                <h3>❌ Устройство не найдено</h3>
            </Container>
        );
    }

    const brandName = device.brand?.name || device.brand || 'Не указан';

    return (
        <Container className="mt-3 mt-md-4 px-2 px-md-3">
            <Card className="p-3 p-md-4 shadow-sm" style={{ borderRadius: '20px', backgroundColor: 'rgba(255,255,255,0.95)' }}>
                <Row>
                    {/* Левая колонка — большая картинка */}
                    <Col xs={12} md={6} className="mb-3 mb-md-0">
                        <Image 
                            src={`/images/${device.img}`}
                            style={{ 
                                width: '100%', 
                                height: 'auto',
                                maxHeight: '400px',
                                objectFit: 'contain',
                                borderRadius: '15px',
                                backgroundColor: '#f8f9fa'
                            }}
                            onError={(e) => {
                                e.target.src = 'https://picsum.photos/500/500';
                            }}
                        />
                    </Col>

                    {/* Правая колонка — вся информация */}
                    <Col xs={12} md={6} className="d-flex flex-column justify-content-between">
                        <div>
                            <h2 className="mb-2" style={{ color: '#333', fontSize: '1.5rem' }}>{device.name}</h2>
                            <p className="text-muted mb-3">Бренд: {brandName}</p>

                            {/* Рейтинг со звездой */}
                            <div className="d-flex align-items-center mb-3">
                                <span className="fw-bold me-2" style={{ fontSize: '1.2rem' }}>
                                    {device.rating || 0}
                                </span>
                                <Image src={star} width={24} height={24} />
                            </div>

                            {/* Цена */}
                            <h3 className="mb-3" style={{ color: '#ff7ad5', fontWeight: '700', fontSize: '1.5rem' }}>
                                {device.price} ₽
                            </h3>

                            {/* Описание */}
                            <div className="mb-4">
                                <h6 className="fw-bold">Описание:</h6>
                                <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#555' }}>
                                    {device.description || 'Описание отсутствует'}
                                </p>
                            </div>
                        </div>

                        {/* Кнопка в корзину */}
                        <Button 
                            variant={added ? 'success' : 'dark'}
                            className="w-100 py-3"
                            style={{ 
                                borderRadius: '30px',
                                fontSize: '1.1rem',
                                fontWeight: '600'
                            }}
                            onClick={handleAddToBasket}
                            disabled={added}
                        >
                            {added ? '✅ Добавлено в корзину' : '🛒 Добавить в корзину'}
                        </Button>
                    </Col>
                </Row>
            </Card>
        </Container>
    );
});

export default DevicePage;
